module.exports = __webpack_public_path__ + "img/vehicle-panamera.e21fb182.jpg";